export default {"src":"/_next/static/media/success.colour.c00f1aef.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};